import React, {useCallback, useMemo, useState} from 'react';

import PdfRender from '../PDFRender';
import {
  FieldDataPoint,
  isPdfDocument,
  normalizeFieldDataPoints
} from '../utils/polygonUtils';

import ImageWithPolygonOverlay from './ImageWithPolygonOverlay';

interface DocumentPreviewWithOverlaysProps {
  location?: string;
  fieldDataPoints?: FieldDataPoint[];
  fileName?: string;
}

const WRAPPER_STYLE: React.CSSProperties = {
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const PDF_WRAPPER_STYLE: React.CSSProperties = {
  width: '100%',
  height: '100%'
};

const IMAGE_STYLE: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: '100%',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain'
};

const DocumentPreviewWithOverlays: React.FC<
  DocumentPreviewWithOverlaysProps
> = ({location, fieldDataPoints, fileName}) => {
  const [page, setPage] = useState(1);
  const [, setImgLoaded] = useState(false);

  const isPDF = useMemo(
    () => isPdfDocument(location, fileName),
    [location, fileName]
  );

  const normalizedPolygons = useMemo(
    () => normalizeFieldDataPoints(fieldDataPoints),
    [fieldDataPoints]
  );

  const handleImageLoad = useCallback(() => {
    setImgLoaded(true);
  }, []);

  if (!location) {
    return null;
  }

  return (
    <div style={WRAPPER_STYLE}>
      {isPDF ? (
        <div style={PDF_WRAPPER_STYLE}>
          <PdfRender
            pdfUrl={location}
            handleImageLoad={handleImageLoad}
            setPage={setPage}
            setImgLoaded={setImgLoaded}
            polygons={normalizedPolygons}
            carouselHeight={510}
          />
        </div>
      ) : (
        <ImageWithPolygonOverlay
          src={location}
          alt="preview"
          style={IMAGE_STYLE}
          polygons={normalizedPolygons}
          page={page}
          onLoad={handleImageLoad}
        />
      )}
    </div>
  );
};

export default React.memo(DocumentPreviewWithOverlays);
